import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { UPDATE_JOB_TITLE } from "../job-title.queries";
import { parseParams } from "../../../helpers/clean-object";

import { UpdateJobTitleInput } from "../../../__generated__/globalTypes";
import {
  UpdateJobTitleMutation,
  UpdateJobTitleMutationVariables,
} from "../../../__generated__/UpdateJobTitleMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdateJobTitle = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdateJobTitleInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdateJobTitleMutation,
    UpdateJobTitleMutationVariables
  >(UPDATE_JOB_TITLE, {
    refetchQueries: "active",
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateJobTitle?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateJobTitle?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
